import { createRoot, type Root } from "react-dom/client";
import Resources from "../pages/Resources/Resources";
import "../index.css";
import "../pages/Resources/Resources.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;
  root = createRoot(element);
  root.render(<Resources />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADResources = { mount, unmount };

function boot() {
  const element = document.getElementById("resources-root");
  if (element) mount(element);
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
else boot();
